import React, { FC } from 'react';
import classNames from 'classnames';

import { ReactComponent as IconClose } from 'imgs/svg-icons/IconClose.svg';

import './Toast.css';

type ToastProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  type?: 'default' | 'error';
  showDismissButton?: boolean;
  onDismiss?: () => void;
};

const Toast: FC<ToastProps> = ({
  title,
  description,
  icon,
  onMouseEnter,
  type = 'default',
  showDismissButton,
  onDismiss
}) => {
  const className = classNames('Toast', {
    'Toast--error': type === 'error'
  });

  return (
    <div className={className} onMouseEnter={onMouseEnter}>
      {icon && <div className="Toast__icon">{icon}</div>}
      <div className="Toast__content">
        {title && <strong className="Toast__title">{title}</strong>}
        {description && <p className="Toast__description">{description}</p>}
      </div>
      {showDismissButton && (
        <button className="Toast__dismissButton" onClick={onDismiss}>
          <IconClose />
        </button>
      )}
    </div>
  );
};

export default Toast;
